import { AbstractControl, ValidatorFn } from '@angular/forms';

export function validDateValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    const value = control.value;
    if (!value) {
      return null; // Valid if no value (optional field)
    }

    const inputDate = new Date(value);
    inputDate.setHours(0, 0, 0, 0); // Reset time to start of the day
    if (isNaN(inputDate.getTime())) {
      return { invalidDate: { value } }; // Invalid date format
    }

    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to start of the day
    if (inputDate > today) {
      return { futureDate: { value } }; // Date is in the future
    }

    return null; // Valid
  };
}
